import Button from './button';
export default Button;
